import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-card-item',
    templateUrl: './card-item.component.html',
    styleUrls: ['./card-item.component.scss'],
    standalone: true
})
export class CardItemComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
